





















import Vue from "vue";
import Component from "vue-class-component";

@Component({
  components: {},
})
export default class UrlBox extends Vue {
  private heroHeader =
    "You have been selected to join Tyr Intelligence & Security";
  private signUpText =
    "You have been chosen from a list of thousands of applicants to get a chance to join the ranks of the Tyr elite " +
    "operators. Fill out this form to enroll in one of our extensive training programs, which will prepare you to " +
    "face any challenges.";
}
